import { createAsyncThunk, createAction } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { UpdateStudentBody } from "@shared-kernel/application/ports/student/student-repository";

export const updateStudentProfile = createAsyncThunk<void, UpdateStudentBody, { extra: Partial<Dependencies> }>(
  "students/updateStudentProfile",
  async (body: UpdateStudentBody, { extra: { studentRepository } }) => {
    await studentRepository!.update(body);
  },
);

export const resetUpdateStudentProfile = createAction("students/resetUpdateStudentProfile");
